import type { HelpButtonItem, HelpLinkItem } from '@ardoq/page-layout';
import { type I18nLocale, t } from '@ardoq/i18n';
import { trackEventV2 } from 'tracking/tracking';

export type TrackedHelpButtonItem = HelpButtonItem & { trackingLabel?: string };

export type TrackedHelpLinkItem = HelpLinkItem & { trackingLabel?: string };

type TrackedHelpItemLabel = {
  key: string;
  englishLabel: string;
};

export const trackedHelpItemLabel = (
  i18nLocale: I18nLocale,
  { key, englishLabel }: TrackedHelpItemLabel
): { label: string; trackingLabel: string } => ({
  label: t(i18nLocale, key, englishLabel),
  trackingLabel: englishLabel,
});

const trackHelpItemClick = (label: string): void => {
  trackEventV2({
    event: 'TopBar0 Help item clicked',
    payload: { label },
  });
};

export const withHelpItemTracking = ({
  trackingLabel,
  ...item
}: TrackedHelpButtonItem): HelpButtonItem => {
  if (
    item.type === 'header' ||
    item.type === 'panel-header' ||
    item.type === 'video'
  ) {
    return item;
  }
  const onTrack = () => {
    item.onTrack?.();
    trackHelpItemClick(trackingLabel ?? item.label);
  };
  return { ...item, onTrack };
};
